<template>
  <div class="page-header">
    <h1 class="page-title">{{ title }}</h1>
    <button 
      v-if="showAddButton" 
      class="btn btn-primary add-button"
      @click="$emit('add-clicked')"
    >
      <i class="fas fa-plus"></i> {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    showAddButton: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Add New'
    }
  },
  emits: ['add-clicked']
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #343a40;
  margin: 0;
}

.add-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn {
  padding: 0.625rem 1.25rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background-color: #3498db;
  color: white;
}

.btn-primary:hover {
  background-color: #2980b9;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}
</style> 